export const option = {
  selection: true, // 行可勾选
  column: [
    {
      width: 100,
      label: '序号',
      value: 'index',
      fixed: true
    },
    {
      width: 100,
      label: '用户ID',
      value: 'complexId', // 微信Id/浏览器Id
      fixed: true
    },
    {
      width: 200,
      label: '答卷ID',
      value: 'id',
      fixed: true
    },
    {
      width: 150,
      label: '流水编号',
      value: 'serialNumber'
    },
    {
      width: 200,
      label: '提交时间',
      value: 'subTime'
    },
    {
      width: 120,
      label: '答卷状态',
      value: 'type'
    },
    {
      width: 300,
      label: '答卷位置',
      value: 'position'
    },
    {
      width: 150,
      label: '回收渠道',
      value: 'channel'
    },
    {
      width: 210,
      label: '子渠道',
      value: 'name'
    },
    {
      width: 210,
      label: '质控方式',
      value: 'qcType'
    },
    {
      width: 150,
      label: '质控人',
      value: 'user'
    },
    {
      width: 200,
      label: '质控时间',
      value: 'zkTime'
    },
    {
      width: 150,
      label: '一审质控人',
      value: 'supervisorName'
    },
    {
      width: 200,
      label: '一审质控时间',
      value: 'reviewTime'
    },
    {
      width: 200,
      label: '说明',
      value: 'Explain'
    },
    {
      width: 180,
      label: '操作',
      value: 'menu',
      fixed: 'right'
    }
  ]
}
export const option231025 = {
  selection: true, // 行可勾选
  column: [
    {
      width: 100,
      label: '序号',
      value: 'index',
      fixed: true
    },
    // {
    //   width: 100,
    //   label: '用户ID',
    //   value: 'complexId', // 微信Id/浏览器Id
    //   fixed: true
    // },
    {
      width: 200,
      label: '答卷ID',
      value: 'id',
      fixed: true
    },
    {
      width: 150,
      label: '流水编号',
      value: 'serialNumber'
    },
    {
      width: 200,
      label: '提交时间',
      value: 'subTime'
    },
    {
      width: 120,
      label: '答卷状态',
      value: 'type'
    },
    {
      width: 300,
      label: '答卷位置',
      value: 'position'
    },
    {
      width: 150,
      label: '回收渠道',
      value: 'channel'
    },
    // {
    //   width: 210,
    //   label: '子渠道',
    //   value: 'name'
    // },
    {
      width: 210,
      label: '质控方式',
      value: 'qcType'
    },
    {
      width: 150,
      label: '质控人',
      value: 'user'
    },
    {
      width: 200,
      label: '质控时间',
      value: 'zkTime'
    },
    {
      width: 150,
      label: '一审质控人',
      value: 'supervisorName'
    },
    {
      width: 200,
      label: '一审质控时间',
      value: 'reviewTime'
    },
    {
      width: 200,
      label: '说明',
      value: 'Explain'
    },
    {
      width: 160,
      label: '操作',
      value: 'menu',
      fixed: 'right'
    }
  ]
}
export const option251014 = {
  selection: true, // 行可勾选
  column: [
    {
      width: 100,
      label: '序号',
      value: 'index',
      fixed: true
    },
    // {
    //   width: 100,
    //   label: '用户ID',
    //   value: 'complexId', // 微信Id/浏览器Id
    //   fixed: true
    // },
    {
      width: 500,
      label: '答卷ID',
      value: 'id',
      // fixed: true
    },
    // {
    //   width: 150,
    //   label: '流水编号',
    //   value: 'serialNumber'
    // },
    // {
    //   width: 200,
    //   label: '提交时间',
    //   value: 'subTime'
    // },
    {
      width: 100,
      label: '答卷状态',
      value: 'type'
    },
    // {
    //   width: 300,
    //   label: '答卷位置',
    //   value: 'position'
    // },
    // {
    //   width: 150,
    //   label: '回收渠道',
    //   value: 'channel'
    // },
    // {
    //   width: 210,
    //   label: '子渠道',
    //   value: 'name'
    // },
    // {
    //   width: 210,
    //   label: '质控方式',
    //   value: 'qcType'
    // },
    // {
    //   width: 150,
    //   label: '质控人',
    //   value: 'user'
    // },
    // {
    //   width: 200,
    //   label: '质控时间',
    //   value: 'zkTime'
    // },
    // {
    //   width: 150,
    //   label: '一审质控人',
    //   value: 'supervisorName'
    // },
    // {
    //   width: 200,
    //   label: '一审质控时间',
    //   value: 'reviewTime'
    // },
    // {
    //   width: 200,
    //   label: '说明',
    //   value: 'Explain'
    // },
    {
      width: 160,
      label: '操作',
      value: 'menu',
      fixed: 'right'
    }
  ]
}
export const exportRecordOption = {
  column: [
    {
      width: 80,
      label: '导出类型',
      value: 'type'
      // fixed: true
    },
    {
      width: 170,
      label: '时间',
      value: 'createTime' // 微信Id/浏览器Id
      // fixed: true
    },
    {
      // width: 100,
      label: '状态',
      value: 'status' // 微信Id/浏览器Id
      // fixed: true
    },
    {
      width: 100,
      label: '操作',
      value: 'opt'
      // fixed: 'right'
    }
  ]
}
